module.exports = __webpack_public_path__ + "static/img/3Dicon.8a44b767.png";